"use client";

import { useEffect, useState } from "react";

import api from "@/config/axiosInstance";
import { endpoints } from "@/config/endpoints";

type Metrics = {
  active_users: number;
  uptime_days: number;
  requests_today: number;
};

export default function MetricsStrip() {
  const [metrics, setMetrics] = useState<Metrics | null>(null);

  useEffect(() => {
    let isMounted = true;
    api.get(endpoints.landing.metrics)
      .then((response) => {
        if (isMounted) {
          setMetrics(response.data);
        }
      })
      .catch(() => {
        if (isMounted) {
          setMetrics({ active_users: 0, uptime_days: 0, requests_today: 0 });
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="grid gap-6 rounded-3xl border border-[var(--stroke)] bg-[var(--panel)]/60 p-6 text-sm text-[var(--text)] md:grid-cols-3">
      <div>
        <p className="text-xs uppercase tracking-[0.3em] text-[var(--subtle)]">
          Active Users
        </p>
        <p className="mt-2 text-2xl font-semibold">
          {metrics ? metrics.active_users.toLocaleString() : "--"}
        </p>
      </div>
      <div>
        <p className="text-xs uppercase tracking-[0.3em] text-[var(--subtle)]">
          Uptime
        </p>
        <p className="mt-2 text-2xl font-semibold">
          {metrics ? `${metrics.uptime_days} days` : "--"}
        </p>
      </div>
      <div>
        <p className="text-xs uppercase tracking-[0.3em] text-[var(--subtle)]">
          Requests Today
        </p>
        <p className="mt-2 text-2xl font-semibold">
          {metrics ? metrics.requests_today.toLocaleString() : "--"}
        </p>
      </div>
    </div>
  );
}
